module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"checklist.clear.title":"ล้างค่าที่เลือกไว้"}}')
  delete Component.options._Ctor
}
